var map = {
	"./": 1376,
	"./Clutch": 2663,
	"./Clutch.js": 2663,
	"./NewUi": 2664,
	"./NewUi.js": 2664,
	"./OldUi": 2665,
	"./OldUi.js": 2665,
	"./index": 1376,
	"./index.js": 1376,
	"./style": 850,
	"./style.js": 850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4193;